import { Dialog } from "primereact/dialog";
import React from "react";
import CustomeButton from "~/components/Button";

const DeleteModal = ({
  visible,
  isDeleteLoading,
  closeModal,
  deleteMessage,
}) => {
  return (
    <Dialog visible={visible} modal className="delete-message-modal">
      <div className="delete-message-container">
        <h3 className="header">
          {" "}
          Are you sure you want to delete this file/message?
        </h3>
        <p className="content">
          Deleting this message will remove it from the conversation. This
          action cannot be undone.
        </p>
      </div>

      <div className="action-container">
        <CustomeButton label="Cancel" onClick={closeModal} />
        <CustomeButton
          label="Yes,Delete"
          variant="remove"
          loading={isDeleteLoading}
          onClick={deleteMessage}
          disabled={isDeleteLoading}
        />
      </div>
    </Dialog>
  );
};

export default DeleteModal;
